import { Component } from '@angular/core';

@Component({
    selector: 'app-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.scss'],
    standalone: false,
})
export class RecoverPasswordComponent {}
